
import {zip as observableZip,  Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { DateConverter, MyDatePickerModel } from '../../helpers/date.converter';
import { AddConsultationDto, ConsultationSearchModel, ConsultationTimeSlot, GetAccountDetailsDto } from '../../models/account/account.models';
import { ConsultationsConfigDto } from '../../models/adverts/advert.models';
import { Address } from '../../models/common/address';
import { AccountService } from '../../services/account.service';
import { MatchingAdvertService } from '../../services/matching.advert.service';

@Component({
    selector: 'book-consultation',
    template: require('./book.consultation.component.html')
})
export class BookConsultationComponent implements OnInit {

    showCatLocError = false;
    @BlockUI('categories-and-locations-block') private catAndLocBlock : NgBlockUI;
    categoryFilter: string;
    subscribed: boolean;
    userId: number;
    datePickerOptions: any;
    dateFrom: MyDatePickerModel;
    timeslots: ConsultationTimeSlot[];
    selectedTimeslot: number;
    details: GetAccountDetailsDto;
    request: AddConsultationDto;
    saveDisabled: boolean;
    buttonText: string;
    blurb: string;

    constructor(private readonly accountService: AccountService,
        private matchingAdvertService: MatchingAdvertService,
        loggedInUserService: LoggedInUserService,
        private readonly router: Router
    ) {

        var user = loggedInUserService.getCurrentUser();
        this.userId = user.userId;
        this.subscribed = !user.canAdHoc('notSubscribed');
        var today = new Date();
        this.datePickerOptions = {
            dateFormat: 'dd/mm/yyyy',
            disableWeekends: true,
            disableUntil: { year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() - 1 }
        };
        this.details = new GetAccountDetailsDto();
        this.details.address = new Address();
        
        this.request = new AddConsultationDto();
        this.request.currentlySourcing = false;
        this.request.supplierId = this.userId;
        this.saveDisabled = true;
    }

    ngOnInit() {
        this.getAccountDetails();
        this.getConfigDetails();
    }

    getAccountDetails() {
        this.accountService.getAccountDetails().subscribe((response: GetAccountDetailsDto) => {
            this.details = response;
            this.request.name = this.details.firstName + ' ' + this.details.lastName;
            this.request.email = this.details.emailAddressPrefix + '@' + this.details.emailAddressSuffix;
            this.request.telephone = this.details.phoneNumber;
        });
    }

    getConfigDetails() {
        this.matchingAdvertService.showConsultationButton(this.userId).subscribe((res: ConsultationsConfigDto) => {
            if (res.buttonText != '') {
                this.buttonText = res.buttonText;
                this.blurb = res.blurb;
            }
        });
    }

    dateChanged() {

        var dto = new ConsultationSearchModel();
        dto.date = DateConverter.toServerString(this.dateFrom);

        var eventObservable = this.accountService.getConsultationTimeslots(dto);

        observableZip(
            eventObservable,
            (timeslots: ConsultationTimeSlot[]) => ({ timeslots }))
            .subscribe(results => {
                this.timeslots = results.timeslots;
            });
    }

    timeslotSelected() {
        this.saveDisabled = false;
    }

    save() {

        this.request.consultationDate = DateConverter.toServerString(this.dateFrom);
        this.request.selectedTimeslot = this.selectedTimeslot;

        this.accountService.bookConsultation(this.request).subscribe(() => {
            this.router.navigateByUrl('/tenders/mymatches');
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/book.consultation.component.ts